<div id="shopping-cart" class="sidenav">
    <div class="sidebar-header">
        <a class="closebtn" (click)="closeShoppingCart()">
            <img src="./assets/img/times.svg" class="img-fluid icon-close" width="17">
        </a>
        <h1 class="mb-2" align="center">
            <b>Resumen</b>
        </h1>
    </div>


    <!-- PRODUCTO CONTRATADO -->
    <!------------------------->
    <div *ngIf="typeOrder !== 'mobile' && order && rateFtth">
        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <h6 class="resumen-color">
                <b>{{ typeOrder === 'convergent' ? 'Fibra y móvil' : 'Solo Fibra' }}</b>
            </h6>
            <small class="text-muted trash-carrito">
                <!-- editar producto -->
                <a (click)="goToStep(0)">
                    <img src="./assets/img/edit.svg" class="img-fluid icon-nav-sidebar" width="15">
                </a>
            </small>
        </div>


        <!-- INFO GENERAL -->
        <!-- <p class="info-nav-sidebar verde">Información general</p> -->
        <!-- dirección normalización -->
        <h6 class="info-nav-sidebar">
            <span class="sidebar-info">
                <img src="./assets/img/map-pin2.svg" class="img-fluid" width="13">
                Dirección de instalación
                <br>
                <b>{{ getAddress() }}</b>
            </span>
        </h6>
        <!-- teléfono a portar -->
        <h6 class="info-nav-sidebar" *ngIf="order.mobiles && order.mobiles.length">
            <span class="sidebar-info">
                <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                {{ order.mobiles[0].msisdn && order.mobiles[0].msisdn !== '' ? 'Línea móvil a portar ' + order.mobiles[0].msisdn : 'Alta línea móvil' }}
            </span>
        </h6>


        <!-- CONCEPTOS -->
        <!-- <div class="resumen d-flex justify-content-between align-items-center">
            <span class="sidebar-info4 verde"> Conceptos</span>
            <small class="text-muted">
            </small>
        </div> -->
        <div class="resumen d-flex justify-content-between align-items-center">
            <!-- tarifa -->
            <span class="sidebar-info5">
                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                {{ rateFtth.name }}
            </span>
            <small class="text-muted">
                <!-- Precio tarifa -->
                <span class="sidebar-info3"><b>{{ priceWithIVA(rateFtth?.rateAmount).toFixed(0) }} €/mes</b></span>
            </small>
        </div>


        <!-- cuando escogemos el pack, la línea ya debe mostrarse aunque aún no esté añadida al order, así que tiramos de ratesMobile para esta sección  -->
        <div class="resumen d-flex justify-content-between align-items-center" *ngIf="ratesMobiles.length">
            <!-- tarifa -->
            <span class="sidebar-info5">
                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                {{ ratesMobiles[0]?.name }} ({{ ratesMobiles[0]?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})
                <br>
                {{ ratesMobiles[0]?.labelData }} + {{ ratesMobiles[0]?.resumeLabelVoice }}
            </span>
            <small class="text-muted">
                <!-- Precio tarifa -->
                <span class="sidebar-info3">
                    <b>{{ priceWithIVA(ratesMobiles[0]?.rateAmount).toFixed(0) }} €/mes</b>
                </span>
            </small>
        </div>

        <br>
        <div class="resumen d-flex justify-content-between align-items-center mt-2" *ngIf="typeOrder === 'convergent'">
            <span class="sidebar-info">
                Descuento por fibra y móvil
            </span>
            <small class="text-muted trash-carrito">
                <!-- Precio tarifa -->
                <span class="sidebar-info2">
                    <b>-{{ priceWithIVA(rateFtth.discount).toFixed(0) }} €/mes</b>
                </span>
            </small>
        </div>

        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <span class="sidebar-info">
                <b>Total</b>
            </span>
            <small class="text-muted trash-carrito">
                <!-- Precio tarifa -->
                <span class="sidebar-info2">
                    <b *ngIf="typeOrder !== 'convergent'">
                        {{ priceWithIVA(+rateFtth?.rateAmount).toFixed(0) }} €/mes
                    </b>
                    <b *ngIf="typeOrder === 'convergent'">
                        {{ priceWithIVA(+rateFtth?.rateAmount + (ratesMobiles[0] ? +ratesMobiles[0]?.rateAmount - +rateFtth.discount : 0)).toFixed(0) }} €/mes
                    </b>
                </span>
            </small>
        </div>
    </div>
    <!-- ./PRODUCTO CONTRATADO -->
    <!--------------------------->

    <div *ngFor="let rateMobile of ratesMobiles; index as i" [hidden]="typeOrder === 'convergent' && i === 0">
        <br>

        <!-- PRODUCTO CONTRATADO -->
        <!------------------------->
        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <h6 class="resumen-color">
                <b>{{ i === 0 ? 'Línea principal' : 'Línea adicional' }}</b>
            </h6>
            <span class="d-flex justify-content-end align-items-center">
                <small class="text-muted trash-carrito">
                    <!-- editar producto -->
                    <a (click)="goToStep(i + (rateFtth ? 1 : 0))">
                        <img src="./assets/img/edit.svg" class="img-fluid icon-nav-sidebar" width="15">
                    </a>
                </small>
                <small class="text-muted trash-carrito" *ngIf="i > 0">
                    <!-- eliminar producto -->
                    <a (click)="removeExtraLine(i)" class="ps-2">
                        <img src="./assets/img/trash.svg" class="img-fluid icon-nav-sidebar" width="15">
                    </a>
                </small>
            </span>
        </div>


        <!-- INFO GENERAL -->
        <!-- <p class="info-nav-sidebar verde">Información general</p> -->
        <!-- teléfono a portar -->
        <h6 class="info-nav-sidebar" *ngIf="order.mobiles[i]">
            <span class="sidebar-info">
                <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                {{ order.mobiles[i].msisdn && order.mobiles[i].msisdn !== '' ? 'Línea móvil a portar ' + order.mobiles[i].msisdn : 'Alta línea móvil' }}
            </span>
        </h6>


        <!-- CONCEPTOS -->
        <!-- <div class="resumen d-flex justify-content-between align-items-center">
            <span class="sidebar-info4 verde"> Conceptos</span>
            <small class="text-muted">
            </small>
        </div> -->
        <div class="resumen d-flex justify-content-between align-items-center">
            <!-- tarifa -->
            <span class="sidebar-info5">
                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                {{ rateMobile?.name }} ({{ order.mobiles[i]?.rate?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})
                <br>
                {{ rateMobile?.labelData }} + {{ rateMobile?.resumeLabelVoice }}
            </span>
            <small class="text-muted">
                <!-- Precio tarifa -->
                <span *ngIf="rateFtth && i === 0" class="sidebar-info3">
                    <b>{{ priceWithIVA(+rateMobile?.rateAmount - +rateFtth.discount).toFixed(0) }} €/mes</b>
                </span>
                <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info3">
                    <b>{{ priceWithIVA(rateMobile?.rateAmount).toFixed(0) }} €/mes</b>
                </span>
            </small>
        </div>
        <br>

        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <span class="sidebar-info"><b>Total</b></span>
            <small class="text-muted trash-carrito">
                <!-- Precio tarifa -->
                <span *ngIf="rateFtth && i === 0" class="sidebar-info2">
                    <b>{{ priceWithIVA(rateMobile?.rateAmount - rateFtth.discount).toFixed(0) }} €/mes</b>
                </span>
                <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info2">
                    <b>{{ priceWithIVA(+rateMobile?.rateAmount).toFixed(0) }} €/mes</b>
                </span>
            </small>
        </div>
        <!-- ./PRODUCTO CONTRATADO -->
        <!--------------------------->
    </div>

    <ng-template [ngIf]="totalPrice !== 0" [ngIfElse]="emptyShoppingCart">
        <div>
            <br>
            <hr class="line-a">
            <br>

            <!-- <div class="resumen d-flex justify-content-between align-items-center">
                <span class="sidebar-info">Importe sin <b>IVA</b></span>
                <small class="text-muted trash-carrito"> -->
                    <!-- Importe sin IVA -->
                    <!-- <span class="sidebar-info2"><b>{{ totalPrice.toFixed(0) }} €/mes</b></span>
                </small>
            </div> -->

            <!-- Importe Total -->
            <div class="resumen-total total d-flex justify-content-between align-items-center"
                *ngIf="(rateFtth && ratesMobiles.length > 1) || (!rateFtth && ratesMobiles.length > 1)">
                <h5 class="total-color"><b>total</b></h5>
                <h5 class="text-auto"><b>{{ priceWithIVA(totalPrice).toFixed(0) }} €/mes</b></h5>
            </div>
            <div class="resumen-total total d-flex justify-content-between align-items-center">
                <span class="total-color"><b>IVA incluido</b></span>
            </div>
        </div>
    </ng-template>
    <ng-template #emptyShoppingCart>
        <div class="container">
            <p class="py-4">Todavía no se han añadido servicios al pedido.</p>
        </div>
    </ng-template>


</div>
